import * as types from '../actions/types';

export const authInitialState = {
    user: null,
    error: null
};

const authReducer = (state = authInitialState, {type, payload}) => {
    switch (type) {
        case types.USER_LOGIN_SUCCESS:
            return {
                ...state,
                user: payload,
                error: null,
            };
        case types.USER_LOGIN_FAILURE:
            return {
                ...state,
                error: payload,
            };
        case types.USER_LOGOUT:
            return {
                ...state,
                user: null,
                error: null,
            };
        default:
            return state;
    }
};

export default authReducer;
